import { useEffect, useRef, useState } from "react";
import SpeechRecognition, { useSpeechRecognition } from "react-speech-recognition";

const ALLOW_TO_SPEAK = 50;

export const useSpeechController = (onFinalTranscript) => {
  const { transcript, listening, resetTranscript, browserSupportsSpeechRecognition } = useSpeechRecognition();

  const silenceTimerRef = useRef(null);
  const finalTranscriptRef = useRef("");

  const [timer, setTimer] = useState(null);

  useEffect(() => {
    finalTranscriptRef.current = transcript;
  }, [transcript]);

  const intervalRef = useRef(null);

  const start = () => {
    if (listening) return;
    
    // Clear any existing interval
    if (intervalRef.current) {
        clearInterval(intervalRef.current);
    }

    resetTranscript();
    finalTranscriptRef.current = "";
    setTimer(ALLOW_TO_SPEAK);

    SpeechRecognition.startListening({
      continuous: true,
      interimResults: true
    });

    intervalRef.current = setInterval(() => {
      setTimer(prev => {
        if (prev === null) {
          if (intervalRef.current) clearInterval(intervalRef.current);
          return null;
        }
        if (prev <= 1) {
          if (intervalRef.current) clearInterval(intervalRef.current);
          stop();
          return null;
        }
        return prev - 1;
      });
    }, 1000);
  };

  const stop = () => {
    SpeechRecognition.stopListening();
    if (intervalRef.current) {
        clearInterval(intervalRef.current);
        intervalRef.current = null;
    }
    setTimer(null);

    const finalText = finalTranscriptRef.current.trim();
    if (finalText) {
      onFinalTranscript(finalText);
    }
  };


  return {
    transcript,
    listening,
    timer,
    start,
    stop,
    browserSupportsSpeechRecognition
  };
};

